import { Box, Button, Stack, Typography } from "@mui/material";
import { paths } from "src/paths";

export const UsageBuy = (props) => (
  <Box
    sx={{
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center",
    }}
  >
    <Stack
      alignItems="center"
      spacing={2}
      sx={{ p: 3 }}
    >
      <Box
        sx={{
          width: 100,
          "& img": {
            width: "100%",
          },
        }}
      >
        <img src="/assets/iconly/iconly-glass-tick.svg" />
      </Box>
      <Typography
        align="center"
        variant="h6"
      >
        사용권 신청
      </Typography>
      <Typography
        align="center"
        variant="body2"
      >
        다양한 서비스 사용을 위하여 사용권 신청을 해주세요.
      </Typography>
      <Button
        variant="contained"
        href={paths.dashboard.pricing.index}
      >
        신청하기
      </Button>
    </Stack>
  </Box>
);
